module.exports = __webpack_public_path__ + "static/media/Contract Manufacturers Infographic mobile 07-02-2024 C.804135cd.gif";